import { useEffect, Dispatch } from "react";
import { useDispatch } from "react-redux";
import { auth } from "firebase/app";
import { toastr } from "react-redux-toastr";

import { authChangeFailure, authChangeSuccess } from "../../store/modules/session/actions";

export const useSubscribeOnAuthStateChanged = (setSemaphore: Dispatch<boolean>) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = auth().onAuthStateChanged(
      (user) => {
        setSemaphore(user === null);
        dispatch(authChangeSuccess(user));
      },
      (error) => {
        toastr.error("Firebase Auth Error", error.message);
        dispatch(authChangeFailure(error));
      }
    );

    return () => {
      unsubscribe();
    }
  }, [setSemaphore, dispatch]);
};
